"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGAEventHandler = createGAEventHandler;

/**
 * Expecting ReactGA from
 * https://www.npmjs.com/package/react-ga
 *
 * Expecting ga function from analytics.js
 * https://developers.google.com/analytics/devguides/collection/analyticsjs
 *
 * Expecting gtag function from gtag.js
 * https://developers.google.com/gtagjs/reference/api#event
 */

/**
 * Trying to enable support for two types of Google Analytics libraries
 * I admit this is quick and dirty
 * Probably should be refactored later
 */
function createGAEventHandler(lib, type) {
  return function (eventObj) {
    var category = eventObj.category,
        action = eventObj.action,
        label = eventObj.label;

    if (type === 'react-ga' && typeof lib.event === 'function') {
      lib.event({
        category: category,
        action: action,
        label: label
      });
    } else if (type === 'ga' && typeof lib === 'function') {
      lib('send', {
        hitType: 'event',
        eventCategory: category,
        eventAction: action,
        eventLabel: label
      });
    } else if (type === 'gtag' && typeof lib === 'function') {
      lib('event', action, {
        event_category: category,
        event_label: label
      });
    }
  };
}